 <template>
    <div class="components-container">
<!--        <div class="filter-container">-->
<!--            <el-input v-model="queryForm.xm" placeholder="姓名" style="width: 150px;"></el-input>-->
<!--            <el-select v-model="queryForm.zt" filterable placeholder="状态" style="width:160px;" clearable>-->
<!--                <el-option v-for="item in comboOption.kpryzt" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">-->
<!--                </el-option>-->
<!--            </el-select>-->

<!--            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询-->
<!--            </el-button>-->
<!--            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>-->
<!--            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>-->
<!--        </div>-->
        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
                  element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
                  :height="mainTableHeight" ref="mainTable">
<!--            <el-table-column type="selection" width="55" />-->
            <el-table-column label="账号" prop="zh" align="center"></el-table-column>
            <el-table-column label="姓名" prop="xm" align="center"></el-table-column>
            <el-table-column label="是否通知" prop="sftz" align="center" :formatter="formatsftz"></el-table-column>
            <el-table-column label="是否接受" prop="sfjs" align="center" :formatter="formatsfjs"></el-table-column>
            <el-table-column label="操作" width="200px" align="center">
                <template slot-scope="scope">
                    <el-button type="info" size="small" @click="modRec(scope.row)">
                        <i class="el-icon-info"></i>&nbsp;详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                           :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum"
                           layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <!-- 表单区域 -->
        <el-dialog class="customElRow" :title="CurdDialogTitle" :visible.sync="CurdDialogVisible" @closed="closeCurdDialog" width="800px" top="150px">
            <el-form ref="editForm" :model="editForm" label-width="120px" label-position="left" :rules="EditRules" v-loading="loading" element-loading-text="拼命加载中">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试编号">
                            {{ editForm.ksbh }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证书名称">
                            {{ formatzsmc(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="课程名称">
                            {{ editForm.kcmc }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考试日期" prop="ksrq">
                            {{editForm.ksrq}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试时间" prop="examTime">
                            {{editForm.kskssj +'~'+ editForm.ksjssj}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考评员" prop="jkry">
                            {{ formatjkry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="督导人员" prop="ddry">
                            {{ formatddry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考务人员" prop="xkry">
                            {{ formatxkry(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="考试场地" prop="kscd">
                            {{ formatkscd(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="考试情况">
                            {{ formatksqk(editForm) }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button v-show="buttomShow" type="success" size="small" @click="sfjsksap('2')">接受</el-button>
                <el-button v-show="buttomShow" type="danger" size="small" @click="sfjsksap('3')">拒绝</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {confirmMsg, showNotify} from "utils/message";
export default {
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 20,
                zh: null,
            },
            //表单数据
            editForm: {
                id: null,
                ksbh: null,//考试编号
                zsmc: null,//证书名称
                kcbh: null,//课程编号
                kcmc: null,//课程名称
                ksrq: null,//考试日期
                kskssj: null,//考试开始时间
                ksjssj: null,//考试结束时间
                jkry: null,//监考人员
                ddry: null,//督导人员
                xkry: null,//巡考人员
                zkry: null,//主考人员
                kscd: null,//考试场地
                kscc: null,//考试场次
                kskcbid: null,//考试课程表编号
                ksqk: null,//考试情况
            },
            comboOption: {
                kpryzt: [],//是否状态
            },
            zsmc: [],//证书名称下拉数据
            ksqk: [],//考试情况下拉数据
            people: [],//人员下拉框数据
            site: [],//考试场地下拉框数据
            site2: [],//考试场地下拉框数据
            address: [],//考试场地地址下拉框数据
            jszt: [],//是否通知、是否接受下拉数据
            editFlag: false,
            //表数据
            tableData: [],
            //默认页数
            total: null,
            CurdDialogTitle: "",
            CurdDialogVisible: false,
            //选中行的数据
            selectRowData: null,
            tableLoading: true,
            mainTableHeight: 500,
            CurdRules: {},
        }
    },
    mounted() {
        this.queryList();
        this.initCombo();//查下拉数据
        this.$nextTick().then(() => {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
            };
        });
    },
    methods: {
        queryList() {
            var url = window.location.href;
            const queryString = url.split('?')[1]
            console.log('查询条件:',queryString)
            if (queryString) { //查询条件不为空
                // 将查询参数字符串解析为键值对
                const queryParams = {};
                queryString.split('&').forEach(param => {
                    const [key, value] = param.split('=');
                    // 如果值已经存在，则将其转换为数组存储
                    if (queryParams[key]) {
                        if (Array.isArray(queryParams[key])) {
                            queryParams[key].push(decodeURIComponent(value));
                        } else {
                            queryParams[key] = [queryParams[key], decodeURIComponent(value)];
                        }
                    } else {
                        queryParams[key] = decodeURIComponent(value);
                    }
                });
                console.log('编号:',queryParams['bh'])
                this.queryForm.zh = queryParams['bh']
                this.$nextTick().then(() => {
                    this.tableLoading = true;
                    console.log('zh：'+this.queryForm.bh)
                    this.$api.examManageJnrd.evaluatorsLogin.queryList({
                        data: this.queryForm,
                    }).then((res) => {
                        this.total = res.data.data.total;
                        this.tableData = res.data.data.list;
                        this.tableLoading = false;
                    }).catch((err) => {
                        this.tableLoading = false;
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            }

        },
        //获取下拉框数据（是否状态）
        initCombo() {
            this.$api.examManageJnrd.evaluatorsLogin.initCombo({}).then((res) => {
                this.zsmc = res.data.data.zsmc;
                this.ksqk = res.data.data.ksqk;
                this.people = res.data.data.people;
                this.site = res.data.data.site;
                this.address = res.data.data.address;
                this.jszt = res.data.data.jszt;
            }).catch((err) => {
                showNotify('错误', error, 'error', 3000);
            });
        },
        getValueByKey(arr, keyToFind) {
            const item = arr.find(item => item.comboValue === keyToFind);
            return item ? item.comboName : '';
        },
        formatsftz(row) {
            console.log('是否通知',row.sftz)
            return this.getValueByKey(this.jszt,row.sftz);
        },
        formatsfjs(row) {
            return this.getValueByKey(this.jszt,row.sfjs);
        },
        formatzsmc(row) {
            return this.getValueByKey(this.zsmc,row.zsmc);
        },
        formatksqk(row) {
            return this.getValueByKey(this.ksqk,row.ksqk);
        },
        formatjkry(row) {
            let jkrystr = '';
            let jkrys = (row.jkry+"").split(",");
            if (jkrys.length>0){
                for (let i = 0; i < jkrys.length; i++) {
                    if (i!==jkrys.length-1){
                        jkrystr += this.getValueByKey(this.people,jkrys[i])+',';
                    } else {
                        jkrystr += this.getValueByKey(this.people,jkrys[i]);
                    }
                }
            }
            return jkrystr;
        },
        formatddry(row) {
            let ddrystr = '';
            let ddrys = (row.ddry+"").split(",");
            if (ddrys.length>0){
                for (let i = 0; i < ddrys.length; i++) {
                    if (i!==ddrys.length-1){
                        ddrystr += this.getValueByKey(this.people,ddrys[i])+',';
                    } else {
                        ddrystr += this.getValueByKey(this.people,ddrys[i]);
                    }
                }
            }
            return ddrystr;
        },
        formatxkry(row) {
            let xkrystr = '';
            let xkrys = (row.xkry+"").split(",");
            if (xkrys.length>0){
                for (let i = 0; i < xkrys.length; i++) {
                    if (i!==xkrys.length-1){
                        xkrystr += this.getValueByKey(this.people,xkrys[i])+',';
                    } else {
                        xkrystr += this.getValueByKey(this.people,xkrys[i]);
                    }
                }
            }
            return xkrystr;
        },
        formatkscd(row) {
            let kscdstr = '';
            let kscds = (row.kscd+"").split(",");
            if (kscds.length>0){
                for (let i = 0; i < kscds.length; i++) {
                    if (i!==kscds.length-1){
                        kscdstr += this.getValueByKey(this.address,kscds[i])+',';
                    } else {
                        kscdstr += this.getValueByKey(this.address,kscds[i]);
                    }
                }
            }
            return kscdstr;
        },
        modRec(rowData) {
            console.log('编行数据：',rowData)
            this.selectRowData = rowData;
            this.$api.examManageJnrd.evaluatorsLogin.queryKsapById({
                data: {
                    'ksapid': rowData.ksapid,
                },
            }).then((res) => {
                console.log('考试安排数据信息：',res)
                this.editExamInfo(res.data.data.list)
                this.CurdDialogTitle = "编辑";
                this.CurdDialogVisible = true;
                this.editFlag = true;
            }).catch((err) => {
                console.log(err);
            });
        },
        editExamInfo(row){
            this.editForm.id = row.id;
            this.editForm.ksbh = row.ksbh;
            this.editForm.zsmc = row.zsmc;
            this.editForm.kcbh = row.kcbh;
            this.editForm.kcmc = row.kcmc;
            this.editForm.ksrq = row.ksrq;
            this.editForm.kskssj = row.kskssj;
            this.editForm.ksjssj = row.ksjssj;
            this.editForm.jkry = row.jkry;
            this.editForm.ddry = row.ddry;
            this.editForm.xkry = row.xkry;
            this.editForm.zkry = row.zkry;
            this.editForm.kscd = row.kscd;
            this.editForm.kskcbid = row.kskcbid;
            this.editForm.kscc = row.kscc;
            this.editForm.ksqk = row.ksqk;
        },
        //关闭对话框
        closeCurdDialog() {
            this.CurdDialogVisible = false;
        },
        //页码区域方法
        handleCurrentChange(val, old) {
            this.selectRowData = val;
        },
        handleSizeChange(val) {
            this.queryForm.rowNum = val;
            this.queryForm.pageNum = 1;
            this.queryList();
        },
        handleFilter() {
            this.queryForm.pageNum = 1;
            this.queryList();
        },
        handlePageChange(val) {
            this.queryForm.pageNum = val;
            this.queryList();
        },
        handleReset() {
            this.queryForm.pageNum = 1;
            this.queryForm.rowNum = 20;
            this.tableLoading = false;
            this.queryList();
        },


    }
}
</script>

<style scoped>
.customElRow .el-row {
    padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// candidateList.vue?62f5e82c